<template>
	<span class="content">
		Modet e kanalit jane <b>{{ message.text }}</b>
	</span>
</template>

<script>
export default {
	name: "MessageChannelMode",
	props: {
		network: Object,
		message: Object,
	},
};
</script>
